export default "__VITE_ASSET__CPU39rYA__"